import React from "react";
import trash from "../../../../assets/images/regular-trash.png";
import nodata from "../../../../assets/images/nodata.svg";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import LoaderComponent from "../../../../components/LoaderComponent/LoaderComponent";
const EnrollmentResponsiveCards = ({
  data = [],
  userType,
  onCardClick,
  onToggleStatus,
  modal = false,
  isAssignedTab =false,
  showActions = true,
  styles = {},
  selectedIds = [],
  onToggle,
  emptyText = "No data available",
  LineTwoText = "",
  statuses = [],
  pagination = null,
  loading = false,
  onDelete,
}) => {
  const getIdLabel = () => {
    const labels = {
      student: "Student Id",
      teacher: "Teacher Id",
      advisor: "Advisor Id",
      specialist: "Specialist Id",
    };
    return labels[userType] || "ID";
  };
  const getPaginationRange = (currentPage, totalPages) => {
    const delta = 1; // pages around current
    const range = [];
    const rangeWithDots = [];

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      }
    }

    let last = null;
    for (let i of range) {
      if (last !== null) {
        if (i - last === 2) {
          rangeWithDots.push(last + 1);
        } else if (i - last > 2) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      last = i;
    }

    return rangeWithDots;
  };
  const isServerPagination =
    pagination && typeof pagination === "object" && pagination.onChange;

  const pageSize = pagination?.pageSize ?? 12;

  const totalPages = isServerPagination
    ? Math.ceil((pagination.total || 0) / pageSize)
    : 1;

  const currentPage = pagination?.currentPage || 1;

  const handlePageChange = (page) => {
    pagination?.onChange?.(page);
  };

  const getIdValue = (item) => {
    const idMap = {
      student: item.id,
      teacher: item.id,
      advisor: item.id,
      specialist: item.id,
    };
    return idMap[userType] || "-";
  };

  const renderCard = (item) => {
    const isActive =
      statuses?.[item.id] !== undefined
        ? statuses[item.id]
        : item.is_active ?? false;
    return (
      <div
        key={item.id}
        className="w-full p-2 bg-white rounded-2xl shadow-md border border-gray-200"
      >
        {/* 🔹 Top Section */}
        <div className=" flex items-center justify-between mb-3">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            {modal && (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  onToggle(item);
                }}
                className={`w-[18px] h-[18px] rounded-full border-2 flex items-center justify-center cursor-pointer
      ${
        selectedIds.includes(item.key)
          ? "border-[#0068FF] bg-[#0068FF]"
          : "border-gray-900 bg-gray-400"
      }
    `}
              >
                {selectedIds.includes(item.key) && (
                  <div className="w-[8px] h-[8px] rounded-full border-2 bg-white"></div>
                )}
              </div>
            )}
            <img
              src={item.profilePic}
              alt={item.name}
              className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
            />
            <div className="min-w-0">
              <p className="text-sm font-semibold text-gray-900 truncate">
                {item.name}
              </p>
              <p className="text-xs text-gray-500 truncate">
                {item.email || "-"}
              </p>
            </div>
          </div>

          {userType === "department" ? (
            <div
              className="flex items-center gap-2 px-2 py-1 rounded-full flex-shrink-0 ml-2 w-max"
              style={{
                background:
                  styles?.[item.role?.toLowerCase()]?.background || "#eee",
              }}
            >
              <span
                className="text-[11px] font-medium"
                style={{
                  color: styles?.[item.role?.toLowerCase()]?.color || "#555",
                  textTransform:
                    styles?.[item.role?.toLowerCase()]?.textTransform ||
                    "capitalize",
                }}
              >
                {item.role || "Role not specified"}
              </span>
            </div>
          ) : showActions &&(
            !modal && (
              <div
                onClick={() => onToggleStatus(item.id, isActive, item.user_id)}
                className={`relative  w-[90px] h-[30px] rounded-full cursor-pointer flex items-center transition-all ${
                  isActive ? "bg-[#E0F4FF]" : "bg-gray-100"
                }`}
              >
                <span
                  className={`absolute text-[12px] font-medium transition-all ${
                    isActive ? "left-3 text-[#007DC5]" : "left-8 text-gray-400"
                  }`}
                >
                  {isActive ? "Active" : "Inactive"}
                </span>
                <div
                  className={`absolute w-[22px] h-[22px] bg-white rounded-full shadow transition-all ${
                    isActive ? "right-1" : "left-1"
                  }`}
                />
              </div>
            )
          )}
        </div>
        {/* 🔹 Info Grid */}
        <div className="grid grid-cols-2 gap-y-3 text-sm mb-4">
          {userType !== "department" ? (
            <div>
              <p className="text-gray-500">{getIdLabel()}</p>
              <p className="font-medium text-gray-900">{getIdValue(item)}</p>
            </div>
          ) : null}

          {(userType === "advisor" || userType === "specialist") && (
            <div>
              <p className="text-gray-500">Student Enrolled</p>
              <p className="font-medium text-gray-900">
                {item.studentsEnrolled || 0}
              </p>
            </div>
          )}

          {userType === "department" && (
            <div>
              <p className="text-gray-500">Department Courses</p>
              <p className="font-medium text-gray-900">
                {item.departmentCourses || 0}
              </p>
            </div>
          )}
          {userType === "student" && (
            <div>
              <p className="text-gray-500">Grade</p>
              <p className="font-medium text-gray-800">{item.grade || "-"}</p>
            </div>
          )}

          {/* {userType === "department" && (
            <div>
              <p className="text-gray-500">Join Date</p>
              <p className="font-medium text-gray-800">
                {item.joinDate || "-"}
              </p>
            </div>
          )} */}


          {userType !== "department" && (
            <div>
              <p className="text-gray-500">{isAssignedTab ? "Assigned On" :"Join Date"}</p>
              <p className="font-medium text-gray-800">
                {item.joinDate || item.created_at || "-"}
              </p>
            </div>
          )}
        </div>
        {!modal && (
          <button
            onClick={() => onCardClick && onCardClick(item)}
            className="w-full border !border-[#0068FF] text-blue-600 bg-white font-medium py-2 rounded-lg text-sm hover:bg-blue-50 transition"
          >
            {userType === "advisor" || userType === "specialist"
              ? "View Students"
              : "View Profile"}
          </button>
        )}
        {(userType === "advisor" || userType === "specialist") && (
          <button   onClick={(e) => {
    e.stopPropagation();
    onDelete && onDelete(item);
  }} className="w-full border-none text-gray-600 bg-white font-medium py-2 rounded-lg text-sm">
            <span className="m-1">
              {" "}
              <img width="13" height="13" src={trash} alt="trash" />
            </span>
            Remove {userType === "advisor" ? "Advisor" : "Specialist"}
          </button>
        )}
      </div>
    );
  };

  if (!data.length) {
    return (
      <div className="text-center text-gray-500 py-6 text-sm">
        <div style={{ fontSize: 28, marginBottom: 8 }}>
          <img src={nodata} alt="no data" />
        </div>
        {emptyText}
        {LineTwoText && <div style={{ marginTop: 4 }}>{LineTwoText}</div>}
      </div>
    );
  }
  return (
    // <div className="flex items-center flex-col gap-4 p-4 m-0">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-1 m-0">
      {data.map((item) => renderCard(item))}
      {pagination && totalPages > 1 && (
        <div className="flex items-center justify-between min-w-[32px] mt-4 px-2">
          <span
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
            className="px-2 py-1 rounded bg-white border text-sm transition disabled:opacity-30 hover:bg-gray-100"
            title={"Previous Page"}
          >
            <ChevronLeft fontSize="small" />
          </span>


          <div className="flex items-center gap-1">
            {getPaginationRange(currentPage, totalPages).map((page, index) =>
              page === "..." ? (
                <span key={index} className="px-2 text-gray-500">
                  ...
                </span>
              ) : (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  className={`px-2 py-1 rounded border text-sm transition
              ${
                currentPage === page
                  ? "bg-blue-500 text-white border-blue-500"
                  : "bg-white text-gray-700 hover:bg-gray-100"
              }
            `}
                >
                  {page}
                </button>
              ),
            )}
          </div>

          <button
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
            className="px-2 py-1 rounded border bg-white text-sm transition disabled:bg-gray-100"
            title={"Next Page"}
          >
            <ChevronRight fontSize="small" />
          </button>
        </div>
      )}
    </div>
  );
};

export default EnrollmentResponsiveCards;